import { render, staticRenderFns } from "./NoPermission.vue?vue&type=template&id=7d2d857f&scoped=true&"
import script from "./NoPermission.vue?vue&type=script&lang=js&"
export * from "./NoPermission.vue?vue&type=script&lang=js&"
import style0 from "./NoPermission.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NoPermission.vue?vue&type=style&index=1&id=7d2d857f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2d857f",
  null
  
)

export default component.exports